import React from "react";
import { notification } from "../../utils/Notifications.tsx";
import { deleteDocumentType } from "../../services/documentTypes.service.ts";
import { useDispatch } from "react-redux";
import { setFetch } from "../../store/slices/documentTypeSlice.ts";

interface DeleteDocumentTypeProps {
  name: string;
  id: number;
  closeFn: () => void;
}

const DeleteDocumentType: React.FC<DeleteDocumentTypeProps> = ({
  name,
  id,
  closeFn,
}) => {
  const dispatch = useDispatch();

  const handleDelete = async () => {
    try {
      await deleteDocumentType(id);
      notification("", `Tipo de documento "${name}" eliminado correctamente`, "info");
      dispatch(setFetch());
    } catch (error: any) {
      notification(
        "Error",
        error?.message || `Ocurrió un error al eliminar el tipo de documento`,
        "danger"
      );
    } finally {
      closeFn();
    }
  };

  return (
    <React.Fragment>
      <p className="fs-15px">
        ¿Estás seguro de que deseas eliminar el tipo de documento "{name}"?
      </p>
      <div className="d-flex justify-content-end">
        <button className="btn btn-secondary me-2" onClick={() => closeFn()}>
          Cancelar
        </button>
        <button className="btn btn-danger" onClick={() => handleDelete()}>
          Eliminar
        </button>
      </div>
    </React.Fragment>
  );
};

export default DeleteDocumentType;
